import type { IReceiptSettings, TReceiptSendMode } from '@feathr/blackbox';

/**
 * Golden-goose config format - nested structure used for both sending TO and receiving FROM iframe
 */
export interface IGoldenGooseConfig {
  branding?: {
    primaryColor?: string;
  };
  content?: {
    customMessage?: string;
    message?: string;
  };
  sender?: {
    fromName?: string;
    fromEmail?: string;
    sendMode?: TReceiptSendMode;
  };
}

/**
 * Convert backend snake_case config to nested format for golden-goose (for sending TO iframe)
 */
export function toEditorConfig(config: IReceiptSettings): IGoldenGooseConfig {
  return {
    branding: {
      primaryColor: config.primary_color,
    },
    content: {
      customMessage: config.custom_message,
      message: config.custom_message,
    },
    sender: {
      fromName: config.from_name,
      fromEmail: config.from_email,
      sendMode: config.send_mode,
    },
  };
}

/**
 * Convert golden-goose nested config to backend snake_case config (for receiving FROM iframe)
 */
export function fromEditorConfig(config: IGoldenGooseConfig): IReceiptSettings {
  return {
    primary_color: config.branding?.primaryColor,
    custom_message: config.content?.customMessage ?? config.content?.message,
    from_name: config.sender?.fromName,
    from_email: config.sender?.fromEmail,
    send_mode: config.sender?.sendMode,
  };
}

const ENV_CONFIG: Record<string, string> = {
  'blackbox.feathr.co': 'https://forms.feathr.co',
  'blackbox-staging.feathr.co': 'https://forms-staging.feathr.co',
  'blackbox-qa.feathr.co': 'https://forms-qa.feathr.co',
  'blackbox-dev.feathr.co': 'https://forms-dev.feathr.co',
};

const LOCAL_CONFIG = {
  url: 'https://local.feathr.app:9009/',
  origin: 'https://local.feathr.app:9009',
};

export function getEmailConfiguratorUrl(): { url: string; origin: string } {
  if (globalThis.location.hostname.includes('local.feathr.app')) {
    return LOCAL_CONFIG;
  }

  for (const [blackboxHost, formsOrigin] of Object.entries(ENV_CONFIG)) {
    if (BLACKBOX_URL.includes(blackboxHost)) {
      return {
        url: `${formsOrigin}/email-configurator/index.html`,
        origin: formsOrigin,
      };
    }
  }

  return LOCAL_CONFIG;
}
